'use client';
import React, { memo } from 'react';
import Image from 'next/image';

import { ITypo } from '@/app/_components/common';
import { Wrapper } from '@/app/_components/layout';
import { Images } from '@/app/assets/images';
import { cn } from '@nextui-org/react';

import { DESCRIPTION, KEYWORDS } from './educational.constant';

const EducationalSection: React.FC = () => {
	return (
		<div className="bg-mauvelous">
			<Wrapper className="relative px-3 pt-0 lg:pt-0">
				<div className="bg-bittersweet relative mx-auto w-fit rounded-b-3xl px-10 pb-3 pt-4 lg:-top-10 lg:rounded-t-3xl lg:py-[37px]">
					<ITypo
						size={20}
						weight="semi"
						className="lg:text-40 text-white"
					>
						TRIẾT LÝ GIÁO DỤC
					</ITypo>
				</div>
				<div className="mt-8 grid grid-cols-1 gap-x-6 lg:mb-[38px] lg:mt-[50px] lg:grid-cols-2">
					<div className="flex gap-4">
						<div className="col items-center justify-between">
							{KEYWORDS?.map((item, index) => (
								<ITypo
									key={index}
									weight="bold"
									size={40}
									className={cn(
										'lg:text-60 lg:-mb-[10px]',
										item?.color
									)}
								>
									{item?.text}
								</ITypo>
							))}
						</div>

						<div className="my-auto h-[calc(100%_-_44px)] min-w-[2px] bg-white lg:min-w-1" />

						<div className="col gap-6">
							{DESCRIPTION.map((item, index) => (
								<div
									key={index}
									className="row min-h-[94px]"
									data-aos="fade-left"
									data-aos-delay={(index + 1) * 100}
								>
									<div>
										<ITypo size={16}>
											<span className="text-bittersweet">
												{item?.hightLight}
											</span>

											{' - '}

											{item?.text}
										</ITypo>
									</div>
								</div>
							))}
						</div>
					</div>

					<div
						className="relative mt-3 aspect-[629/505] w-full"
						data-aos="flip-left"
					>
						<Image
							src={Images.home.educational}
							alt="DLA Da Nang"
							fill
						/>
					</div>
				</div>
			</Wrapper>
		</div>
	);
};

export default memo(EducationalSection);
